import React from "react";
import { View } from "react-native";
import FastImage from "react-native-fast-image";
import Crown from "../HomeScreen/Crown";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";

const Avatar = ({
  picture,
  isFirst = false,
  size,
  isSmall = false,
  styleAvatar = {},
}) => {
  return (
    <View
      style={[
        styles.avatarView,
        styleAvatar,
        isSmall && {
          marginRight: 3,
          height: size + 5,
          shadowColor: theme.colors["neutral.white"],
          elevation: 0,
        },
      ]}
    >
      {isFirst && (
        <View style={styles.crownView}>
          <Crown height={isSmall ? 12 : 19} width={isSmall ? 21 : 28} />
        </View>
      )}
      <FastImage
        style={[styles.avatar, { height: size, width: size }]}
        source={{ uri: picture }}
        resizeMode="cover"
      />
    </View>
  );
};

Avatar.defaultProps = {
  size: normalize(50),
};

const styles = {
  avatar: {
    width: normalize(50),
    height: normalize(50),
    borderRadius: normalize(25),
    borderWidth: normalize(1),
    borderColor: theme.colors["neutral.white"],
  },
  avatarView: {
    height: normalize(62),
    alignItems: "center",
    justifyContent: "center",
    shadowColor: theme.colors["neutral.900"],
    elevation: 6,
    zIndex: 1,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowRadius: 6,
    shadowOpacity: 0.3,
  },
  crownView: {
    zIndex: 25,
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: 0,
  },
};

export default Avatar;
